// src/components/EnableNotificationsButton.jsx
import { useState, useEffect } from 'react';
import { Bell } from 'lucide-react';
import {
  isNotificationSupported,
  notify,
  requestNotificationPermission,
} from '../utils/notifications';
import { showSuccess, showWarning } from '../utils/toast';

export default function EnableNotificationsButton({ collapsed = false }) {
  const [supported, setSupported] = useState(false);
  const [perm, setPerm] = useState('default');

  useEffect(() => {
    const syncPermission = () => {
      const isSupported = isNotificationSupported();
      setSupported(isSupported);
      if (isSupported) setPerm(Notification.permission);
    };

    syncPermission();
    window.addEventListener('focus', syncPermission);
    document.addEventListener('visibilitychange', syncPermission);
    return () => {
      window.removeEventListener('focus', syncPermission);
      document.removeEventListener('visibilitychange', syncPermission);
    };
  }, []);

  if (!supported || perm === 'granted') return null;

  const handleClick = async () => {
    const p = await requestNotificationPermission();
    setPerm(p);
    if (p === 'granted') {
      notify('Bluezap · Notificações ativadas', {
        body: 'Os alertas do chat interno aparecerão pelo navegador.',
        icon: '/logo.png',
        tag: 'bluezap-notification-permission-test',
        autoCloseAfterMs: 5000,
      });
      showSuccess('Notificações do navegador ativadas.');
      return;
    }

    if (p === 'denied') {
      showWarning('O Chrome bloqueou as notificações. Clique no cadeado ao lado do endereço, abra “Notificações” e selecione “Permitir”.', {
        timeout: 9000,
      });
    }
  };

  return (
    <button
      onClick={handleClick}
      className="header-button"
      title={collapsed ? (perm === 'denied' ? 'Notificações bloqueadas' : 'Ativar notificações') : undefined}
      aria-label={collapsed ? (perm === 'denied' ? 'Notificações bloqueadas' : 'Ativar notificações') : undefined}
    >
      <Bell className="icon" />
      <span>{perm === 'denied' ? 'Notificações bloqueadas' : 'Ativar notificações'}</span>
    </button>
  );
}
